import * as React from 'react'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useHandlers } from './hooks'
import type { RequestStatus } from '@sales-center/common'

type Props = {
  state: RequestStatus
  entityId: number
}

export function ActivitiesListHeader(props: Props) {
  const { state, entityId } = props
  const { handleCreateActivity } = useHandlers()

  const addDisabled = state === 'loading'

  return (
    <Stack>
      <Stack
        direction="row"
        px={2.2}
        pt={1}
        pb={0.8}
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack mr={5.6}>
          <Typography variant="h6" margin={0}>
            Activities
          </Typography>
        </Stack>
        <Button
          size="medium"
          onClick={handleCreateActivity}
          disabled={addDisabled}
          variant="outlined"
          sx={{ border: '1px solid #19305A' }}
          data-test-id={`add-activity-button-${entityId}`}
        >
          <Typography whiteSpace="nowrap" fontFamily="Source Sans Pro Semibold">
            Add Activity
          </Typography>
        </Button>
      </Stack>
    </Stack>
  )
}
